module.exports = __webpack_public_path__ + "static/media/bg7.96e71ce1.jpg";